import { StyledText } from '@app/collections/dynamic-form/elements'
import { Button, Col, Description, DescriptionItem, If, Notification, Row, Spacer, Spin, Text } from '@app/components'
import { InfoCircleOutlined } from '@app/components/icons'
import { IStore } from '@app/redux'
import { auth, Axios, errorHandler, getWallets } from '@app/services'
import { SummaryPropsBuy3 } from '@app/types'
import { toCurrency, toSmallerCurrency } from '@app/utils'
import axios from 'axios'
import { ETHEREUM_MAINNET_ID, useWalletChainId } from 'libs/ethereum/useWalletChainId'
import useBurn from 'libs/services/hooks/useBurn'
import useEhexSell from 'libs/services/hooks/useEhexSell'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount, useSignMessage } from 'wagmi'

import { AddDiscountDrawer } from '../drawers'
import { BurnPendingModal } from '../pending'
import { StyledCard } from './elements'

export const Summary: React.FC<SummaryPropsBuy3> = ({
  purchaseData: { pay, receive },
  //refresh,
  fee,
  //cst,
  //setCst,
  balance,
  //setCoastBalance,
  //transactionRefresh,
  setTransactionRefresh,
}) => {
  //const { user } = useSelector((state: IStore) => state)
  const { user } = useSelector((state: IStore) => state)
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false)
  //const [loading, setLoading] = useState(false)
  //const [pending, setPending] = useState(0)
  //const [percent, setPercent] = useState(0)
  //const [transactionId, setTransactionId] = useState('')
  const [, setLoading] = useState(false)

  const [signed, setSigned] = useState({ wallet: '', signature: '' })
  const [percent, setPercent] = useState(0)
  //const [popupDismissed, setPopupDismissed] = useState(false)
  const { data: signMessageData, error, isPending, signMessage, variables } = useSignMessage()
  const { address } = useAccount()
  const chainId = useWalletChainId()
  const isEhex = pay.type === 'eHEX'
  const burn = useBurn(isEhex ? 0 : pay.amount, actual_shit, isEhex ? 'wPLS' : pay.type)
  const [depositAddress, setDepositAddress] = useState('')
  const [sellLoading, setSellLoading] = useState(false)
  const [priceChecked, setPriceChecked] = useState(false)
  const [priceCheckLoading, setPriceCheckLoading] = useState(false)

  const submitEhexSell = async (hash: string) => {
    if (!hash) return
    try {
      setSellLoading(true)
      const authorization = await auth.currentUser.getIdToken()
      const res: any = await Axios.post(
        '/api/ethereum/sell',
        {
          entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
          amount: pay.amount,
          wallet: address,
          hash,
        },
        { headers: { Authorization: authorization }, timeout: 120000 },
      )
      Notification({
        message:
          res.data.sendStatus === 'confirmed'
            ? `Sold — ${toCurrency(res.data.usdCredited, true)} credited`
            : 'Sell submitted — waiting for confirmation',
        type: 'success',
      })
      setTransactionRefresh(Date.now())
      pay.setAmount(0)
      receive.setAmount(0)
      setPriceChecked(false)
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
    } finally {
      setSellLoading(false)
    }
  }

  const ehexSell = useEhexSell(isEhex ? pay.amount : 0, isEhex ? depositAddress : '', submitEhexSell)
  //const [showPopup, setShowPopup] = useState(false)

  const router = useRouter()

  useEffect(() => {
    setTransactionRefresh(burn.state === 'loading')
  }, [burn.state])

  async function actual_shit(loadingHash) {
    if (loadingHash) {
      const data = {
        loading: true,
        amount: pay.amount,
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        fee: fee,
        wallet: address,
        hash: loadingHash,
        secret: signed.signature,
        token: pay.type,
        expectedAmount: receive.amount,
        sell: true,
      }

      /*const data = {
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        amount: pay.amount,
        expectedAmount: receive.amount,
        token: getAddress[receive.type],
        fee: fee,
        wallet: address,
      }*/
      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await Axios.post('/api/north-one/burn', data, { headers })
      return
    }
    if (burn.hash == 0 || !burn.hash) {
      pay.setAmount(0)
      receive.setAmount(0)
      setLoading(false)
    } else {
      /*if (receive.amount >= 1000) {
        await createTweet(auth, { type: 'burn', amount: pay.amount, address: address, token: pay.type })
      }*/

      setPercent(100)
      setPercent(0)

      pay.setAmount(0)
      receive.setAmount(0)
      setLoading(false)

      //Push user to transactions page
      router.push('/transactions')
    }
  }

  useEffect(() => {
    (async () => {
      if (variables?.message && signMessageData) {
        // eslint-disable-next-line no-console
        //await addWallet(user.uid, address, signMessageData)
        const data = {
          address: address,
          signMessageData: signMessageData,
        }
        const authorization = await auth.currentUser.getIdToken()
        const headers = {
          Authorization: authorization,
        }
        await Axios.post('/api/coast/burn-wallet', data, { headers })
        getSigned(user.uid, address)
      } else if (error) {
        // eslint-disable-next-line no-console
        console.error('Error signing message:', error)
      }
    })()
  }, [signMessageData, variables?.message])

  useEffect(() => {
    getSigned(user.uid, address)
  }, [address, signMessageData, variables])

  const getSigned = async (uid: string, account: string) => {
    if (address != undefined) {
      const signedWallets = await getWallets(uid)

      const numWallets = signedWallets.length

      for (let i = 0; i < numWallets; i++) {
        if (signedWallets[i].Wallet == address) {
          setSigned({ wallet: account, signature: signedWallets[i].Nickname })
          return
        }
      }

      setSigned({ wallet: '', signature: '' })
    } else {
      setSigned({ wallet: '', signature: '' })
    }
  }

  const addSigned = async () => {
    if (address != undefined) {
      const dataToSign = 'Approve Wallet for CST burning'
      // const dataHex = Web3.utils.utf8ToHex(dataToSign)

      signMessage({ account: address, message: dataToSign })
    } else {
      Notification({ message: 'Connect Wallet', type: 'error' })
    }
  }

  const transfer = async () => {
    try {
      if (address != undefined) {
        setLoading(true)
        setPercent(25)
        if (isEhex) {
          if (!ehexSell.write) {
            Notification({ message: 'Wallet not ready to sell. Check Price again on Ethereum.', type: 'error' })
            setLoading(false)
            return
          }
          await ehexSell.write()
          return
        }
        await burn.write()
      }
    } catch (error) {
      setPercent(0)
      setLoading(false)
      Notification({ message: error.response.data, type: 'error' })
      errorHandler.report`Failed to create transaction: ${error}`
    }
  }

  //const [startToken, setStartToken] = useState('')
  //const [endToken, setEndToken] = useState('')
  //const [startAmount, setStartAmount] = useState(0)
  const [response, setResponse] = useState(null)
  //const [callData, setCallData] = useState('')
  const [apiLoading, setAPILoading] = useState(false)
  //const [pending, setPending] = useState(0)
  //const [percent, setPercent] = useState(0)
  //const [generationLoading, setGenerationLoading] = useState(false)
  //const [pendingResponse, setPendingResponse] = useState('')
  //const [transactionId, setTransactionId] = useState<string | undefined>(undefined)
  //const [buyBalance, setBuyBalance] = useState(0)
  const [videoOpen, setVideoOpen] = useState(false)

  // const mint = useMint()

  /*const getAddress = {
    wPLS: '0xA1077a294dDE1B09bB078844df40758a5D0f9a27',
    WAIT: '0x26179a4d4b58b4456f28d19507546596c9058ee5',
    HEX: '0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39',
    PLSX: '0x95B303987A60C71504D99Aa1b13B4DA07b0790ab',
    INC: '0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d',
    PHLPv2: '0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b',
  }*/

  const handleApiCall = async () => {
    try {
      if (pay.type === 'eHEX') {
        setAPILoading(true)
        receive.setAmount('Loading')
        const authorization = await auth.currentUser.getIdToken()
        const result: any = await Axios.post(
          '/api/ethereum/quote',
          { ehex: pay.amount },
          { headers: { Authorization: authorization } },
        )
        setResponse(result)
        receive.setAmount(result.data.usdAfterFee)
        setDepositAddress(result.data.depositAddress)
        setPriceChecked(true)
        return result
      }

      let outToken: string
      let outDecimal: number

      switch (pay.type) {
        case 'wPLS':
          outToken = '0xA1077a294dDE1B09bB078844df40758a5D0f9a27'
          outDecimal = 18
          break
        case 'WAIT':
          outToken = '0x26179a4d4b58b4456f28d19507546596c9058ee5'
          outDecimal = 8
          break
        case 'HEX':
          outToken = '0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39'
          outDecimal = 8
          break
        case 'PLSX':
          outToken = '0x95B303987A60C71504D99Aa1b13B4DA07b0790ab'
          outDecimal = 18
          break
        case 'INC':
          outToken = '0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d'
          outDecimal = 18
          break
        case 'PHLPv2':
          outToken = '0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b'
          outDecimal = 18
          break
        case 'TIDE':
          outToken = '0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf'
          outDecimal = 18
          break
        case 'GLORY':
          outToken = '0x37D16BabDce0427e63233b3d9be149B31ac2E6f8'
          outDecimal = 6
          break
        case 'CST':
          outToken = '0x600136dA8cc6D1Ea07449514604dc4ab7098dB82'
          outDecimal = 6
          break
        default:
          outToken = '0xA1077a294dDE1B09bB078844df40758a5D0f9a27'
          outDecimal = 18
          break
      }
      setAPILoading(true)
      receive.setAmount('Loading')

      const amount = BigInt(((pay.amount * (100 - fee - 0.5)) / 100) * 10 ** outDecimal).toString()
      //eslint-disable-next-line no-console
      console.log(BigInt(amount).toString())

      const result: any = await axios.get(
        `/api/piteas/quote?tokenInAddress=${outToken}&tokenInChainId=369&tokenOutAddress=0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07&tokenOutChainId=369&amount=${amount}&allowedSlippage=2.00`,
      )

      setResponse(result)
      receive.setAmount(result.data.destAmount / 10 ** result.data.destToken.decimals)
      setPriceChecked(true)

      return response
    } catch (error: any) {
      const message = error?.response?.data?.error || error?.message || 'Unable to get price'
      setResponse(message)
      Notification({ message, type: 'error' })
      receive.setAmount(0)
      //setCallData('')
    } finally {
      setAPILoading(false)
    }
  }

  /*useEffect(() => {
    swapAddressBalance(setBuyBalance)
  }, [fee, pay.amount, receive.amount])*/

  useEffect(() => {
    setPriceChecked(false)
    setPriceCheckLoading(false)
    receive.setAmount(0)
  }, [fee, pay.amount, pay.type])

  const checkPrice = async () => {
    setPriceCheckLoading(true)
    if (pay.type && pay.amount != 0 && pay.amount) {
      await handleApiCall()
    } else if (pay.amount == 0 || !pay.amount) {
      receive.setAmount(0)
    }
    setPriceCheckLoading(false)
  }

  /*const createTransaction = async () => {
    try {
      //setPercent(0)
      //setPending(1)
      setGenerationLoading(true)

      const data = {
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        amount: pay.amount,
        expectedAmount: receive.amount,
        token: getAddress[receive.type],
        fee: fee,
        wallet: address,
      }

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }

      const res: any = await Axios.post('/api/north-one/buy', data, { headers })
      //await Axios.post('/api/fortress/buy', data, { headers })

      //setPendingResponse(res.data.buyId)
      setTransactionId(res.data.buyId)

      Notification({ message: 'Buy Initiated', type: 'success' })

      if (pay.amount >= 1000) {
        await createTweet(auth, { type: 'swaps', amount: receive.amount, address: address, token: receive.type })
      }
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      //console.error('API Call Error:', error);
    } finally {
      setResponse(null)
      setGenerationLoading(false)
      setTransactionRefresh(!transactionRefresh)
      pay.setAmount(0)
      //setCallData('')
    }
  }*/

  /*useEffect(() => {
    if (transactionId !== undefined && transactionId !== '') {
      const unsub = onSnapshot(doc(db, 'Transactions', transactionId), (doc) => {
        if (doc.exists) {
          const buyStep = doc.data().buyStep
          switch (buyStep) {
            case 0:
              if (doc.data().status == 'Failed') {
                Notification({ message: 'Transaction failed to process', type: 'error' })
              }
            case 3:
              if (doc.data().buyStep == 3) {
                Notification({ message: 'Swap Completed Successfully', type: 'success' })
              }
              setTransactionRefresh(3)
              break
            case 4:
              Notification({ message: 'Send Beginning', type: 'success' })
              setTransactionRefresh(4)
              break
            case 5:
              Notification({ message: 'Send Completed Successfully', type: 'success' })
              setTransactionRefresh(5)
              break
            case 6:
              Notification({ message: 'Swap Failed, retrying', type: 'error' })
              setTransactionRefresh(6)
              break
            case 7:
              Notification({ message: 'Send Failed, retrying', type: 'error' })
              setTransactionRefresh(7)
              break
          }
        }
      })

      return () => unsub()
    }
  }, [transactionId])*/

  const topLabelItemStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 'bold',
  }

  const topDescriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '18px',
  }

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }

  const labelFeeBoldItemStyle: React.CSSProperties = {
    marginLeft: '16px',
    fontSize: '14px',
  }

  const descFeeBoldItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '14px',
  }

  const summaryDesc = (
    <Row align="middle" gutter={0}>
      <Text style={{ fontSize: '24px' }}>Sell Summary</Text>
      <Button type="text" size="small" onClick={() => setVideoOpen(true)}>
        <InfoCircleOutlined size={20} />
      </Button>
    </Row>
  )

  /*const feeLink = (
    <Button
      type="link"
      style={{ padding: 0, fontSize: '14px' }}
      size="small"
      onClick={() => setDiscountDrawerOpen(true)}
    >
      Fee ({fee}%)
    </Button>
  )*/

  return (
    <>
      <StyledCard>
        <Description title={summaryDesc} column={1}>
          <DescriptionItem label={'Total Cost'} labelStyle={topLabelItemStyle} contentStyle={topDescriptionItemStyle}>
            {`${toCurrency(pay.amount, false)} ${pay.type}`}
          </DescriptionItem>
          <DescriptionItem label={'Total Sell'} labelStyle={topLabelItemStyle} contentStyle={topDescriptionItemStyle}>
            {apiLoading ? <Spin /> : `~${toCurrency(receive.amount, true)} ${receive.type}`}
          </DescriptionItem>
          {chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) && address != undefined && (
            <DescriptionItem label={'Total Fees'} contentStyle={descriptionItemStyle}>
              {`${toCurrency(pay.amount * (fee / 100), false)} ${pay.type}`}
            </DescriptionItem>
          )}

          <DescriptionItem
            label={`Fee (${fee}%)`}
            labelStyle={labelFeeBoldItemStyle}
            contentStyle={descFeeBoldItemStyle}
          >
            {`${toCurrency(pay.amount * (fee / 100), false)} ${pay.type}`}
          </DescriptionItem>

          {isEhex && Number(receive.amount) > 0 && (
            <DescriptionItem label={'Price'} contentStyle={descriptionItemStyle}>
              {`${toSmallerCurrency(Number(receive.amount) / pay.amount, true)} / eHEX`}
            </DescriptionItem>
          )}

          <DescriptionItem label={'Wallet'} contentStyle={descriptionItemStyle}>
            {address != undefined ? address.slice(0, 4) + '...' + address.slice(-4) : 'Connect Wallet'}
          </DescriptionItem>
          <DescriptionItem label={'Remaining Balance'} contentStyle={descriptionItemStyle}>
            {`${toCurrency(balance - pay.amount, false)} ${pay.type}`}
          </DescriptionItem>

          <DescriptionItem label={'Processing in'} contentStyle={descriptionItemStyle}>
            {isEhex ? '~1 Minute' : '~5 Minutes'}
          </DescriptionItem>
        </Description>

        <Spacer />
        <Row>
          {isEhex ? (
            <Col span={24}>
              {!priceChecked && (
                <Button
                  block
                  disabled={address == undefined || !pay.amount || pay.amount <= 0.1 || chainId != ETHEREUM_MAINNET_ID}
                  onClick={checkPrice}
                  loading={priceCheckLoading}
                >
                  {address == undefined ? 'Connect Wallet' : 'Check Price'}
                </Button>
              )}
              {priceChecked && (
                <Button
                  block
                  disabled={
                    address == undefined ||
                    !pay.amount ||
                    apiLoading ||
                    sellLoading ||
                    pay.amount <= 0.1 ||
                    pay.amount > balance ||
                    receive.amount == 0 ||
                    chainId != ETHEREUM_MAINNET_ID ||
                    !depositAddress
                  }
                  onClick={transfer}
                  loading={sellLoading || ehexSell.state === 'loading'}
                >
                  {`Sell ${pay.type} for ${toCurrency(receive.amount, true)}`}
                </Button>
              )}
            </Col>
          ) : (
            <>
              {signed.wallet != address && (
                <Col span={24}>
                  <Button
                    block
                    disabled={
                      address == undefined || chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) || isPending
                    }
                    onClick={() => addSigned()}
                    loading={isPending}
                  >
                    Approve
                  </Button>
                </Col>
              )}
              {signed.wallet == address && (
                <Col span={24}>
                  {!priceChecked && (
                    <Button
                      block
                      disabled={address == undefined || !pay.amount || pay.amount <= 0.1}
                      onClick={checkPrice}
                      loading={priceCheckLoading}
                    >
                      {address == undefined ? 'Connect Wallet' : 'Check Price'}
                    </Button>
                  )}
                  {pay.amount > balance && pay.amount > 0 && (
                    <>
                      <Spacer value={8} />
                      <StyledText>
                        Not enough {pay.type} in this wallet to sell. You can still check the price.
                      </StyledText>
                    </>
                  )}
                  {priceChecked && (
                    <Button
                      block
                      disabled={
                        address == undefined ||
                        !pay.amount ||
                        apiLoading ||
                        pay.amount <= 0.1 ||
                        pay.amount > balance ||
                        receive.amount == 0
                      }
                      onClick={transfer}
                      loading={false}
                    >
                      {`Sell ${pay.type} for ${toCurrency(receive.amount, false)}`}
                    </Button>
                  )}
                </Col>
              )}
            </>
          )}
        </Row>
        <If condition={!isEhex && chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN)}>
          <>
            <Spacer value={20} />
            <StyledText>Connect to PulseChain Mainnet to Sell Pulsechain Assets</StyledText>
          </>
        </If>
        <If condition={isEhex && chainId != ETHEREUM_MAINNET_ID}>
          <>
            <Spacer value={20} />
            <StyledText>Connect to Ethereum Mainnet to sell HEX (eHEX)</StyledText>
          </>
        </If>
        {/* <Button block type="link" onClick={test}>yup</Button> */}
      </StyledCard>

      <AddDiscountDrawer open={discountDrawerOpen} toggleOpen={() => setDiscountDrawerOpen(!discountDrawerOpen)} />

      <BurnPendingModal
        toggleOpen={() => {
          return true
        }}
        percent={percent}
        setPercent={setPercent}
      />

      {videoOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={() => setVideoOpen(false)}
        >
          <div
            style={{
              position: 'relative',
              width: '80%',
              maxWidth: '800px',
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setVideoOpen(false)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <iframe
              width="100%"
              height="450"
              src="https://www.youtube.com/embed/YWl7ZYTlcmE?si=u9H0ygjL0YrN2oCj"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}

      {/***<BuyPendingModal
        pending={pending}
        setPending={setPending}
        toggleOpen={() => {
          return true
        }}
        percent={percent}
        setPercent={setPercent}
        transactionId={pendingResponse}
        token={receive.type}
      />***/}
    </>
  )
}
